document.addEventListener('product-info:loaded', (event) => {
  const productInfo = event.target;

  productInfo.addPreProcessCallback((newVariantSelects) => {
    const newDetails = newVariantSelects.querySelector('details[id^="PatchDetails-"]');
    if (!newDetails) return;

    const oldDetails = document.getElementById(newDetails.id);
    if (oldDetails?.hasAttribute('open')) {
      newDetails.setAttribute('open', '');
    }
  });
});
